module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_2-0b905b120a1f6ddf3136c008ed2de3ad.webp";